import * as React from "react";
import { Col } from "./../Col";
import * as CMP from "../../../../components";
export class Fixture extends React.Component {
    render() {
        return (React.createElement(Col, { modifier: "rj-racing-next-races__col--name" },
            React.createElement(CMP.Fixture, { top: this.props.top, bottom: this.props.bottom })));
    }
}
//# sourceMappingURL=Fixture.js.map